export default __webpack_public_path__ + "static/media/skovstykket-property-02.b4374a90.jpg";